__turbopack_context__.v({
  "canvas": "GBQ39W_canvas",
  "container": "GBQ39W_container",
  "controls": "GBQ39W_controls",
  "svg": "GBQ39W_svg",
});
